(function () {
  "use strict";

  // Product gallery thumbs
  document.querySelectorAll(".blony-product-thumb").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var img = document.getElementById("BlonyProductImage");
      var src = btn.getAttribute("data-image");
      if (img && src) {
        img.src = src;
      }
      document.querySelectorAll(".blony-product-thumb").forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
    });
  });

  // Variant selection on product page
  var form = document.getElementById("BlonyProductForm");
  var variantsEl = document.getElementById("BlonyProductVariants");
  var variantIdInput = document.getElementById("BlonyVariantId");
  var priceEl = document.getElementById("BlonyProductPrice");
  var addBtn = form ? form.querySelector(".blony-add-to-cart") : null;

  if (form && variantsEl && variantIdInput) {
    var variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent || "[]");
    } catch (e) {
      variants = [];
    }

    function getSelectedOptions() {
      var selects = form.querySelectorAll(".blony-variant-select");
      var options = [];
      selects.forEach(function (select) {
        options.push(select.value);
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents);
      }
      return "$" + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var selected = findVariant(getSelectedOptions());
      if (!selected) return;

      variantIdInput.value = selected.id;

      if (priceEl) {
        var html = "";
        if (selected.compare_at_price && selected.compare_at_price > selected.price) {
          html += "<s>" + formatMoney(selected.compare_at_price) + "</s> ";
        }
        html += "<strong>" + formatMoney(selected.price) + "</strong>";
        priceEl.innerHTML = html;
      }

      if (addBtn) {
        if (selected.available) {
          addBtn.disabled = false;
          addBtn.textContent = "Add to cart";
        } else {
          addBtn.disabled = true;
          addBtn.textContent = "Sold out";
        }
      }

      if (selected.featured_image && selected.featured_image.src) {
        var main = document.getElementById("BlonyProductImage");
        if (main) {
          main.src = selected.featured_image.src;
        }
      }
    }

    form.querySelectorAll(".blony-variant-select").forEach(function (select) {
      select.addEventListener("change", updateVariant);
    });
  }
})();
